import type { PropsWithChildren } from 'react';

import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router';

import cn from '@/lib/utils/cn';

import { Button } from '../shadcn/button';

type Props = PropsWithChildren<{
  className?: string;
}>;

export default function SubPageHeader({ children, className }: Props) {
  const navigate = useNavigate();
  const goBack = () => {
    if (window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="flex items-center border-b py-2 shadow">
      <Button onClick={goBack} variant="link">
        <ArrowLeft />
      </Button>

      <div className={cn('flex w-full pr-2', className)}>{children}</div>
    </div>
  );
}
